import React, {Dispatch, SetStateAction} from 'react';
import {theme} from '../../../styles/darkTheme';
import {Text} from './styles';
import Modal from 'react-bootstrap/Modal';

interface Props {
  title: string;
  message: string;
  isVisible: boolean;
  setIsVisible: Dispatch<SetStateAction<boolean>>;
  callback?: () => any;
  children: React.ReactNode
}

const Alert: React.FC<Props> = ({
  isVisible = false,
  setIsVisible,
  title,
  message,
  children,
  callback,
}) => {
  const handleClose = () => {
    setIsVisible(false);
    if (callback) callback();
  };

  return (
    <Modal show={isVisible} onHide={handleClose}>
      <Modal.Header closeButton>
        <Text theme={theme} type="bold">
          {title}
        </Text>
      </Modal.Header>
      <Modal.Body>
        {message && (
          <Text theme={theme} type="normal">
            {message}
          </Text>
        )}
        {children}
      </Modal.Body>
    </Modal>
  );
};

export default Alert;
